import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{sq-field-select content=this.content value=this.value prompt=this.prompt disabled=this.disabled selectClassNames=this.selectClassNames onChange=this.onChange}}", {
  moduleName: "@dashboard/shared-ui/components/sq-field-select-state.hbs"
});